var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A92528",
    fillRule: "evenodd",
    d: "M19.37 1.333c.726 0 1.42.296 1.923.82l2.984 3.104 2.981 3.111c.476.497.742 1.158.742 1.845V28c0 1.473-1.194 2.667-2.667 2.667H6.667C5.194 30.667 4 29.473 4 28V4c0-1.473 1.194-2.667 2.667-2.667H19.37zM17.334 4L6.667 4v24h18.666V12H20c-1.473 0-2.667-1.194-2.667-2.667V4zm4.334 17.334c.552 0 1 .448 1 1V23c0 .552-.448 1-1 1H10.333c-.552 0-1-.448-1-1v-.667c0-.552.448-1 1-1h11.334zm0-5.333c.552 0 1 .448 1 1v.667c0 .552-.448 1-1 1H10.333c-.552 0-1-.448-1-1V17c0-.552.448-1 1-1h11.334zM19.999 4.654L20 9.334l4.489-.002-2.135-2.227-2.355-2.45z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.be7ae6ce.svg";
export { ForwardRef as ReactComponent };